export class AddressVm{
    Id: number = 0;
    Name: string = "";
    PlaceName: string = "";
    StreetNameAndNumber: string = "";
    PostalCode: string = "";
    City: string = "";
    Country: string = "";

}